import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
const trafficLights = [{
  icon: AlertCircleIcon,
  label: 'ROJO',
  title: 'Eliminar hoy',
  description: 'Productos con disruptores endocrinos confirmados que bloquean tus hormonas inmediatamente.',
  bgColor: 'bg-blush-soft',
  cardBorder: 'border-blush',
  dotColor: 'bg-blush-deep',
  iconColor: 'text-blush-ink',
  labelColor: 'text-blush-ink'
}, {
  icon: AlertTriangleIcon,
  label: 'AMARILLO',
  title: 'Sustituir pronto',
  description: 'Elementos con riesgo moderado que debes reemplazar en las próximas semanas.',
  bgColor: 'bg-beige',
  cardBorder: 'border-amber-200',
  dotColor: 'bg-amber-400',
  iconColor: 'text-amber-700',
  labelColor: 'text-amber-800'
}, {
  icon: CheckCircleIcon,
  label: 'VERDE',
  title: 'Seguro',
  description: 'Alternativas limpias y libres de tóxicos que puedes usar con confianza.',
  bgColor: 'bg-sage-soft',
  cardBorder: 'border-sage',
  dotColor: 'bg-sage-deep',
  iconColor: 'text-sage-ink',
  labelColor: 'text-sage-ink'
}];
export function Mechanism() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-151">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-153">
          <span className="inline-block bg-sage-soft text-sage-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-154">
            La metodología
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-ink mb-6" data-id="element-155">
            El Sistema del{' '}
            <span className="text-sage-deep" data-id="element-156">Semáforo Hormonal</span>
          </h2>
          <p className="text-lg md:text-xl text-ink-soft max-w-3xl mx-auto leading-relaxed" data-id="element-157">
            Una metodología de auditoría simple que clasifica tu hogar en tres
            categorías. En solo 14 días, silenciamos el ruido químico para que
            tus hormonas puedan finalmente escucharse de nuevo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-158">
          {trafficLights.map((light, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: index * 0.15
        }} className={`${light.bgColor} border ${light.cardBorder} rounded-2xl p-8 relative`} data-id="element-159">
              <div className="flex items-center gap-3 mb-5" data-id="element-160">
                <span className={`w-3 h-3 rounded-full ${light.dotColor}`} aria-hidden="true" data-id="element-161" />
                <span className={`font-bold text-sm tracking-widest ${light.labelColor}`} data-id="element-162">
                  {light.label}
                </span>
              </div>
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/70 mb-5" data-id="element-163">
                <light.icon className={`w-6 h-6 ${light.iconColor}`} data-id="element-164" />
              </div>
              <h3 className="font-serif text-2xl text-ink mb-3" data-id="element-165">
                {light.title}
              </h3>
              <p className="text-ink-soft leading-relaxed" data-id="element-166">
                {light.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}